import './radioButtonComponent.scss'

import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';

interface RadioButtonComponentProps {
    onUpdate?: Function;
    checked?: boolean;
    value?: any;
    name?: string;
    label?: string;
    size?: "medium" | "small" | undefined;
    color?: "primary" | "secondary" | "default"| "info" | undefined;
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
}

const RadioButtonComponent = (props: RadioButtonComponentProps) => {

        const {onUpdate, checked, label, value, labelPlacement, name} = props;
        let {color, size} = props;
        if (!color) color = "info";
        if (!size) size = "medium";

        return (
            <FormControlLabel
                onChange={() => {
                    if (onUpdate) {
                        onUpdate(value)
                    }
                }}
                labelPlacement={labelPlacement}
                checked={checked}
                value={value}
                label={label}
                name={name}
                control={<Radio size={size} color={color}/>}
            />
        );
    }

;

export default RadioButtonComponent;